<template>
  <v-row
    align="center"
    justify="center"
    no-gutters
    class="background"
  >
    <v-card
      width="90%"
      max-width="400px"
      class="pa-4"
    >
      <v-card-title>Ошибка{{code > 0 ? ' '+code : ''}}...</v-card-title>
      <v-card-text>{{message}}</v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          @click="backClick()"
          icon
        >
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="homeClick()"
          icon
        >
          <v-icon>
            mdi-home-outline
          </v-icon>
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    code: 0,
    message: 'Что-то пошло не так...',
    from: '/'
  }),

  created: function () {
    const code = this.$route.query.code
    if (code) this.code = code

    const message = this.$route.query.message
    if (message) this.message = message

    const from = this.$route.query.from
    if (from) this.from = from
  },

  methods: {
    backClick: function () {
      this.$router.push(this.from)
    },

    homeClick: function () {
      this.$router.push('/')
    }
  }
}
</script>
